import React from 'react';
import PostMessage from '../PostMessage';

const crowdFundTexts = {
  default: {
    crowdFundForIndividual: (
      <ol className="list-inside list-decimal space-y-2 font-dmsans text-15 font-normal">
        <li className="list-none">
          <PostMessage
            message="Your contribution will be processed securely via Stripe. The funds will go to your association’s Stripe-connected account, subject to Stripe’s terms and conditions. Because this is a personal fundraiser—contributions are not tax deductible. The beneficiary receives the funds, minus the payment processor’s standard fee of 2.9% + $0.30.
This fundraiser is hosted on Neki’s platform, which empowers people to do good with ease and transparency. While we do not independently vet every personal fundraiser, we provide tools and support to help hosts and givers stay connected, accountable, and informed.
In the rare event that a fundraiser is canceled or funds cannot be delivered, we will work with Stripe to resolve the issue in line with their policies.
Thank you for showing up for someone in need—your kindness truly makes a difference."
          />
        </li>
      </ol>
    ),
    crowdFundForOrganization: (
      <ol className="list-inside list-decimal space-y-2 font-dmsans text-15 font-normal">
        <li className="list-none">
          <PostMessage
            message="Your contribution will be processed securely via Stripe. The funds will go to your association’s Stripe-connected account, subject to Stripe’s terms and conditions. Because this is a personal fundraiser—contributions are not tax deductible. The beneficiary receives the funds, minus the payment processor’s standard fee of 2.9% + $0.30.
This fundraiser is hosted on Neki’s platform, which empowers people to do good with ease and transparency. While we do not independently vet every personal fundraiser, we provide tools and support to help hosts and givers stay connected, accountable, and informed.
In the rare event that a fundraiser is canceled or funds cannot be delivered, we will work with Stripe to resolve the issue in line with their policies.
Thank you for showing up for someone in need—your kindness truly makes a difference."
          />
        </li>
      </ol>
    ),
  },
};

const getCrowdFundText = (key) => {
  return crowdFundTexts.default[key];
};

export default getCrowdFundText;
